/**
 * Route for `schedule-based-triggers-day-parting-timezone-aware`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { ScheduleBasedTriggersDayPartingTimezoneAwarePage } from "../features/schedule-based-triggers-day-parting-timezone-aware/ScheduleBasedTriggersDayPartingTimezoneAwarePage";

export const scheduleBasedTriggersDayPartingTimezoneAwareRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/schedule-based-triggers-day-parting-timezone-aware",
	component: ScheduleBasedTriggersDayPartingTimezoneAwarePage,
});

export default scheduleBasedTriggersDayPartingTimezoneAwareRoute;
